import classNames from 'classnames';
import { ReactNode, SelectHTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';

export type Option = {
  label: ReactNode;
  value: string;
};

const workOptions = [
  { label: ``, value: `` },
  { label: `○`, value: `1` },
  { label: `×`, value: `2` },
  { label: `午前 ×`, value: `3` },
  { label: `午後 ×`, value: `4` },
];

type Variant = 'fit';
type Props = {
  variants?: Variant[];
  isPossible: boolean;
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className' | 'style'>;

const WorkTimesSelect = forwardRef<HTMLSelectElement, Props>(
  ({ variants = [], isPossible, ...props }, ref) => {
    const variantsClassName = variants.map((v) => styles[v]);
    const selectClassNames = classNames(
      styles.input,
      props.value === '' && styles['not-selected'],
      isPossible ? styles.isPossible : styles.isImpossible,
      ...variantsClassName
    );
    const containerClassNames = classNames(
      styles.container,
      ...variantsClassName
    );

    const icon = () => {
      switch (props.value) {
        case 0:
          return <td className={styles.dataCell} key={props.name}></td>;
        case 1:
          return (
            <FontAwesomeIcon
              icon={faCircle}
              className={styles.isPossibleMark}
            />
          );
        case 2:
          return (
            <FontAwesomeIcon
              icon={faXmark}
              className={styles.isImpossibleMark}
            />
          );
        case 3:
          return (
            <div className={styles.isHalfImpossible}>
              午前
              <FontAwesomeIcon icon={faXmark} className={styles.xIcon} />
            </div>
          );
        case 4:
          return (
            <div className={styles.isHalfImpossible}>
              午後
              <FontAwesomeIcon icon={faXmark} className={styles.xIcon} />
            </div>
          );
      }
    };

    return (
      <div className={containerClassNames}>
        <div className={styles.icon}>{icon()}</div>
        <select {...props} ref={ref} className={selectClassNames}>
          {workOptions.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        <div className={styles.angleIcon} />
      </div>
    );
  }
);
WorkTimesSelect.displayName = 'Select';

export default WorkTimesSelect;
